import { isString } from 'lodash';
import { useMemo } from 'react';

import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { Bean, BindingCreator, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../translations';

type IdentityDocumentSeriesAndNumberFieldProps = {
   readonly name: string;
   readonly register: BindingCreator<Bean>;
   readonly testId?: string;
};

export const IdentityDocumentSeriesAndNumberField = (props: IdentityDocumentSeriesAndNumberFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
         maxLength: IdentityDocument.MAX_LENGTH,
         validate: (seriesAndNumber) =>
            isString(seriesAndNumber) && IdentityDocument.isSeriesAndNumberValid(seriesAndNumber)
               ? true
               : identityDocumentTranslationKeys.identityDocumentSeriesAndNumber.validate.invalidSeriesAndNumber,
      };
   }, []);

   return (
      <TextInput
         testId={props.testId ?? 'identityDocumentSeriesAndNumber'}
         label={identityDocumentTranslationKeys.identityDocumentSeriesAndNumber.label}
         controller={props.register(props.name, validationRules)}
         defaultValue={null}
         placeholder={identityDocumentTranslationKeys.identityDocumentSeriesAndNumber.placeholder}
      />
   );
};
